import { createContext } from 'react';

import { FeatureFlags } from 'featureFlags/constants';
import { useFeatureFlag } from 'shared/hooks';

export const BannerContext = createContext(null);

export const BannerProvider = ({ children, cmsBanner }) => {
  const isBannerEnabled = useFeatureFlag(FeatureFlags.WEB_ENABLE_GOAT_BANNER);
  const values = {
    isBannerEnabled,
    ...cmsBanner,
  };

  return <BannerContext.Provider value={values}>{children}</BannerContext.Provider>;
};
